export const nulinga = {
  linkRef: 'https://nulinga.com/postulantes/new?token=BX4',
  notCompletedText: 'Si todavía no lo completaste, haz',
  resultPendingTitlea: 'Los resultados de tu test están siendo analizados por ',
  resultPendingTitleb: '',
  resultPendingTitleMarketplace: 'El resultado de tu test está siendo procesado',
  text: 'Test de Nivelación de Inglés',
}
